import React, { useRef, useMemo } from 'react';
import { useSpring, animated } from 'react-spring';
import { useGesture } from '@use-gesture/react';
import { usePerformance } from '../hooks/usePerformance';

const MagneticCard = ({ children, className = '' }) => {
  const { isLowPerformance, isReducedMotion } = usePerformance();
  const ref = useRef();
  
  // Reducir sensibilidad en dispositivos lentos
  const sensitivity = useMemo(() => {
    if (isLowPerformance) return 20;
    if (isReducedMotion) return 50;
    return 10;
  }, [isLowPerformance, isReducedMotion]);

  const [{ x, y }, api] = useSpring(() => ({ x: 0, y: 0 }));

  const bind = useGesture({
    onMove: ({ xy: [px, py] }) => {
      if (isReducedMotion) return;
      
      const rect = ref.current.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;
      
      const deltaX = (px - centerX) / sensitivity;
      const deltaY = (py - centerY) / sensitivity;
      
      api.start({ x: deltaX, y: deltaY });
    },
    onHover: ({ hovering }) => {
      if (!hovering) {
        api.start({ x: 0, y: 0 });
      }
    },
  });

  // Si el movimiento está reducido, renderizar sin efectos magnéticos
  if (isReducedMotion) {
    return (
      <div ref={ref} className={`${className}`}>
        {children}
      </div>
    );
  }

  return (
    <animated.div
      ref={ref}
      {...bind()}
      style={{
        transform: x.to((x) => `translateX(${x}px)`).to((x) => `translateY(${y}px)`),
      }}
      className={`magnetic-hover ${className}`}
    >
      {children}
    </animated.div>
  );
};

export default MagneticCard; 